import { render, staticRenderFns } from "./SeleccionarButacasComponent.vue?vue&type=template&id=74e8d4a9"
import script from "./SeleccionarButacasComponent.vue?vue&type=script&lang=js"
export * from "./SeleccionarButacasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports